import {MAIN_REPORT_TABLE, TRANSACTION_REPORT_TABLE} from "../../constants";
import {mainReportColumnsMap} from "../../components/Reports/mainReportColumnsMap";
import {transactionReportColumnsMap} from "../../components/Reports/transactionReportColumnsMap";

// eslint-disable-next-line import/prefer-default-export
export const tableConfigMap = {
  main: {
    tableKey: MAIN_REPORT_TABLE,
    columnsMap: mainReportColumnsMap,
    exportMethod: "mainReportExport",
  },
  transaction: {
    tableKey: TRANSACTION_REPORT_TABLE,
    columnsMap: transactionReportColumnsMap,
    exportMethod: "transactionReportExport",
  },
};
